import clsx from "clsx";
import styled, { css } from "styled-components";

import { Text } from "~/components/Text";
import * as Bulma from "~/types/bulma";

export type TagsProps = Bulma.Addons & Bulma.Sized & Bulma.Alignment;
export const Tags = styled.div.attrs<TagsProps>((props) => ({
  className: clsx({
    [`tags`]: true,
    [`has-addons`]: props.addons,
    [`is-${props.align}`]: Boolean(props.align),
    [`are-${props.sized}`]: Boolean(props.sized),
  }),
}))<TagsProps>``;

export type TagProps = Bulma.Common & Bulma.Roundable & Bulma.Lightable & { transparent?: boolean };

/**
 * @see https://bulma.io/documentation/elements/tag/
 */
export const Tag = styled(Text).attrs<TagProps>((props) => ({
  className: clsx({
    [`tag`]: true,
    [`is-rounded`]: Boolean(props.rounded),
    [`is-light`]: props.light,
    [`is-${props.kind}`]: Boolean(props.kind),
    [`is-${props.sized}`]: Boolean(props.sized),
  }),
}))<TagProps>`
  cursor: default;
  ${(props) =>
    props.transparent &&
    css`
      &&& {
        background-color: transparent;
      }
    `}
`;

export const Button = styled(Tag).attrs({
  as: "button",
  type: "button",
})`
  border: 0;
  cursor: pointer;
`;
